import { render } from "./addModuleGoodsManage.vue?vue&type=template&id=a3c12b8e&scoped=true"
import script from "./addModuleGoodsManage.vue?vue&type=script&lang=js"
export * from "./addModuleGoodsManage.vue?vue&type=script&lang=js"

import "./addModuleGoodsManage.vue?vue&type=style&index=0&id=a3c12b8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3c12b8e"]])

export default __exports__